import * as React from 'react';

import { IGroupSearch } from '@/client/legacy-shared-modules/search/search-types';
import { GroupHit } from '@/imports/ui/components/search/GroupHits';

import { CardDividerList } from '../shared/CardDividerList';

export const GroupsList: React.FC<{
  hits: IGroupSearch[];
}> = ({ hits }) => {
  if (hits.length === 0) {
    return null;
  }

  return (
    <CardDividerList>
      {hits.map((groupHit) => (
        <React.Fragment key={groupHit.objectID}>
          {GroupHit(groupHit, 'default', true)}
        </React.Fragment>
      ))}
    </CardDividerList>
  );
};
